"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentSVGDrawer = void 0;
var tslib_1 = require("tslib");
var svgDrawer_1 = require("./svgDrawer");
var SegmentSVGDrawer = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SegmentSVGDrawer, _super);
    function SegmentSVGDrawer() {
        return _super.call(this, "line", "") || this;
    }
    return SegmentSVGDrawer;
}(svgDrawer_1.SVGDrawer));
exports.SegmentSVGDrawer = SegmentSVGDrawer;



//////////////////
// WEBPACK FOOTER
// ./src/drawers/segmentDrawer.ts
// module id = 54
// module chunks = 0